
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system-riadenia-kvality-vzdelavania",
      function () {
        return require("private-next-pages/system-riadenia-kvality-vzdelavania.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system-riadenia-kvality-vzdelavania"])
      });
    }
  